import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import HealthReportModal from '../Components/HealthReportModal';

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-size: 16px;
  color: #666;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 24px;
  text-align: center;
`;

const ErrorIcon = styled.div`
  font-size: 64px;
  margin-bottom: 16px;
`;

const ErrorTitle = styled.h1`
  font-size: 24px;
  color: #c62828;
  margin: 0 0 8px 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ErrorMessage = styled.p`
  font-size: 16px;
  color: #666;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

/**
 * หน้าสาธารณะสำหรับดู Health Report ผ่าน Share Token
 * URL: /public-healthbook?token=xxx
 *
 * - ไม่ต้อง login
 * - ใช้ JWT token จาก query string
 * - Token หมดอายุตามเวลาที่กำหนด (default 24 ชั่วโมง)
 */
const PublicHealthBookPage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [healthData, setHealthData] = useState(null);

  useEffect(() => {
    const loadHealthReport = async () => {
      try {
        setLoading(true);
        setError(null);

        // ดึง token จาก query string
        const token = searchParams.get('token');

        if (!token) {
          throw new Error('ไม่พบ Token กรุณาตรวจสอบ URL');
        }


        // เรียก API เพื่อดึงข้อมูล health report
        const response = await axios.get(
          `https://mfuwellnesscenter-server.dietz.asia/api/healthbook/public`,
          {
            params: { token },
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );


        if (response.data?.status === 'success' && response.data?.data) {
          setHealthData(response.data.data);
        } else {
          throw new Error('ไม่พบข้อมูล Health Report');
        }
      } catch (err) {

        if (err.response?.status === 401) {
          setError('Token หมดอายุแล้ว กรุณาขอ Token ใหม่');
        } else if (err.response?.status === 404) {
          setError('ไม่พบข้อมูล Health Report');
        } else {
          setError(err.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
        }
      } finally {
        setLoading(false);
      }
    };

    loadHealthReport();
  }, [searchParams]);

  // แสดง Loading
  if (loading) {
    return (
      <PageContainer>
        <LoadingContainer>กำลังโหลดข้อมูล...</LoadingContainer>
      </PageContainer>
    );
  }

  // แสดง Error
  if (error) {
    return (
      <PageContainer>
        <ErrorContainer>
          <ErrorIcon>⚠️</ErrorIcon>
          <ErrorTitle>ไม่สามารถโหลดข้อมูลได้</ErrorTitle>
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorContainer>
      </PageContainer>
    );
  }

  // แสดง Health Report
  return (
    <PageContainer>
      <HealthReportModal
        isOpen={true}
        onClose={() => {
          // ไม่มี close button สำหรับหน้า public
          // หรือจะให้ปิดแล้ว redirect ไปหน้าอื่นก็ได้
        }}
        recordData={healthData}
      />
    </PageContainer>
  );
};

export default PublicHealthBookPage;
